import { Injectable } from "@angular/core";
import { AuthSelector } from "@obg/ngx.core";

import { CommonState } from "../state";

import { CookieNoticeState } from "./cookie-notice.model";

@Injectable({
	providedIn: "root",
})
export class CookieNoticeSelector {
	getState() {
		return (state: CommonState): CookieNoticeState => state.cookieNotice;
	}

	isClosed() {
		return (state: CommonState): boolean => state.cookieNotice.isClosed;
	}

	isVisible() {
		return (state: CommonState): boolean => state.cookieNotice.isVisible;
	}

	isEnabled() {
		return (state: CommonState): boolean | undefined => state.cookieNotice.isEnabled;
	}

	shouldShowCookieNotice() {
		return (state: CommonState): boolean | undefined =>
			!state.cookieNotice.isClosed &&
			!state.cookieNotice.isVisible &&
			state.cookieNotice.isEnabled &&
			!AuthSelector.isAuthenticated(state);
	}
}
